export default {
ourLovelyTeam: "تیم دوست‌داشتنی ما",
meetOurTeamTitle: "با دوستان مهربون ما آشنا شوید",
meetOurTeamDescription: "آدم‌هایی که با عشق و لبخند، دنیای یادگیری بچه‌ها را زیباتر می‌کنند.",
previousSlide: "اسلاید قبلی",
nextSlide: "اسلاید بعدی",
goToSlide: "رفتن به اسلاید",

};
